import { motion } from "framer-motion";
import { BookHeart } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { FormData } from "../types";

interface StoryStepProps {
  formData: FormData;
  onChange: (field: keyof FormData, value: string) => void;
}

const StoryStep = ({ formData, onChange }: StoryStepProps) => {
  return (
    <motion.div
      key="story"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="space-y-6"
    >
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
          <BookHeart className="w-8 h-8 text-primary" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-foreground mb-2">
          Tell Us Your Story
        </h2>
        <p className="text-muted-foreground">
          This is the most important part of the process.
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="story">
          Share your story and what you would like included in the song *
        </Label>
        <Textarea
          id="story"
          placeholder="Tell us about your memories, special moments, inside jokes, what makes this person or relationship special, and anything else you'd like us to know..."
          value={formData.story}
          onChange={(e) => onChange("story", e.target.value)}
          rows={10}
          className="resize-none"
        />
        <p className="text-sm font-medium text-primary">
          ⚠️ This section directly drives your song lyrics
        </p>
        <p className={`text-sm ${formData.story.trim().length >= 50 ? 'text-primary' : 'text-muted-foreground'}`}>
          {formData.story.length} / 50 characters minimum
          {formData.story.trim().length >= 50 && ' ✓'}
        </p>
      </div>
    </motion.div>
  );
};

export default StoryStep;
